import React, { useMemo } from 'react';
import { Typography } from 'antd';
import { evaluatePasswordPolicy } from '../../utils/passwordPolicy';

const { Text } = Typography;

const PasswordPolicyChecklist = ({ password }) => {
  const policy = useMemo(() => evaluatePasswordPolicy(password), [password]);

  return (
    <div style={{ marginBottom: 12 }}>
      {policy.checks.map((item) => (
        <div key={item.key}>
          <Text type={item.valid ? 'success' : 'secondary'}>
            {item.valid ? 'OK' : 'Pendente'} - {item.label}
          </Text>
        </div>
      ))}
    </div>
  );
};

export default PasswordPolicyChecklist;
